import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getConfigText, isIntroException, newLineParser } from "../utils";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';
import TextField from '@mui/material/TextField';


export default function ConclusionPage({ pageId, studentAnswers, setStudentAnswers }) {


    const skills = getConfigText(pageId, "vaardigheden");
    const cardSM = Math.floor(12 / skills.length);

    const BottomContent = () => {
        if (isIntroException(pageId)) {
            return null;
        }

        return (
            <div>
                <Typography variant="body2" gutterBottom component="div">
                    <List>
                        {getConfigText(pageId, "samenvatting")['punten'].map((c, i) => (
                            <ListItem key={"punten_" + i}>
                                <ListItemIcon >
                                    <CircleIcon sx={{ fontSize: '0.7rem' }} />
                                </ListItemIcon>
                                {newLineParser(c)}
                            </ListItem>
                        ))}
                    </List>
                </Typography>

                <Typography
                    variant="h5"
                    gutterBottom
                >
                    Waar sta ik nu?
                </Typography>

                <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                    {studentAnswers.a1}
                </Typography>

                <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                    {newLineParser(getConfigText(pageId, "samenvatting")['vraag1_inleiding'])}
                </Typography>

                <Typography variant="body2" gutterBottom component="div">
                    <List>
                        {getConfigText(pageId, "samenvatting")['vraag1_punten'].map((c, i) => (
                            <ListItem key={"punten1_" + i}>
                                <ListItemIcon >
                                    <CircleIcon sx={{ fontSize: '0.7rem' }} />
                                </ListItemIcon>
                                {newLineParser(c)}
                            </ListItem>
                        ))}
                    </List>
                    <TextField
                        id="outlined-multiline-static"
                        label="Geef hier je antwoord"
                        multiline
                        fullWidth
                        minRows={2}
                        defaultValue={studentAnswers.b1}
                        onChange={(event) => {
                            setStudentAnswers({
                                ...studentAnswers,
                                b1: event.target.value
                            });
                        }}
                    />
                </Typography>

                <Typography variant="body2" gutterBottom component="div">
                    <List>
                        {getConfigText(pageId, "samenvatting")['vraag2_punten'].map((c, i) => (
                            <ListItem key={"punten2_" + i}>
                                <ListItemIcon >
                                    <CircleIcon sx={{ fontSize: '0.7rem' }} />
                                </ListItemIcon>
                                {c}
                            </ListItem>
                        ))}
                    </List>
                    <TextField
                        id="outlined-multiline-static"
                        label="Geef hier je antwoord"
                        multiline
                        fullWidth
                        minRows={2}
                        defaultValue={studentAnswers.b2}
                        onChange={(event) => {
                            setStudentAnswers({
                                ...studentAnswers,
                                b2: event.target.value
                            });
                        }}
                    />
                </Typography>

            </div>
        );
    };

    return (
        <React.Fragment>
            <Typography
                variant="h5"
                gutterBottom
            >
                Samenvatting
            </Typography>

            <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                {newLineParser(getConfigText(pageId, "samenvatting")['inleiding'])}
                {newLineParser(getConfigText(pageId, "samenvatting")['punten_inleiding'])}
            </Typography>

            <BottomContent />

        </React.Fragment>
    );
}
